<template>
    <div id="intro" class="page">
      <div class="head-wrapper">
        <h1 class="head-copy in">You could win reese easter eggs</h1>
        <p class="sub-copy in">Tap below to see if you're a winner</p>
      </div>

      <div class="stage-wrapper">

        <div class="egg-spacer"></div>
        <Button
          label="Try Your Luck"
          :callback="isWinner"
        />
      </div>

    </div>
</template>

<script>
import Button from '../components/shared/Button'
import { mapMutations, mapActions } from 'vuex';


export default {
  name: 'Intro',
  components: {
    Button,
  },

  mounted(){
    console.log('this: ', this)
  },

  methods: {
    ...mapMutations([
      'activateEgg'
    ]),
    ...mapActions(['getResults']),


    isWinner(e){
      console.log('event: ', e.target)

      // Call gtag event
      window.gtag('event', 'btn_click', {
        'event_category': 'home',
        'event_label': 'try_your_luck_btn'
      });

      e.target.closest(".btn-wrapper").classList.add('out');
      this.activateEgg();

      let headers = document.querySelectorAll(" #intro .head-wrapper > *");
      headers.forEach( el => {
        el.classList.remove('in');
        el.classList.add('out');

      })

      window.setTimeout( () => {
        this.getResults()
          .then((hasWon) => {
            // question - vue check is this correct?
            // check session

            window.gtag('event', 'result', {
              'event_category': 'luck_result',
              'event_label': hasWon ? 'win' : 'lose',
            });

            console.log('hasWon: ', this, hasWon);
            this.$router.push('results')

          })
          .catch(() => {
            console.log('fail')
            //this.$router.push('tryagain')
            this.$router.push('results')

          })

          // this.activateAnimIterator()


      }, 3000);

    }
  }

}
</script>

<style lang="scss">

  .head-wrapper {
    // background: red;
    width: 100%;
    height: 27.5vh;
    display: flex;

    flex-direction: column;
    align-items: baseline;
    align-content: center;
    justify-content: baseline;

    .header, h1, h2 {
      margin: auto auto 0.5em auto;
      font-size: 2.4rem;
    }

    .sub-copy {
      margin: 0 auto .75em auto;
      font-size: 1.3rem;
    }


  }

  .stage-wrapper {
    width: 100%;
    height: 60vh;
    // background: blue;
    display: inline-block;

  }

</style>
